import { Component, type ReactNode } from 'react'
import { attemptStaleAssetReload } from './stale-asset-recovery'

interface AppCrashBoundaryProps {
  readonly children: ReactNode
}

interface AppCrashBoundaryState {
  readonly error: Error | null
}

export class AppCrashBoundary extends Component<AppCrashBoundaryProps, AppCrashBoundaryState> {
  state: AppCrashBoundaryState = { error: null }

  static getDerivedStateFromError(error: Error): AppCrashBoundaryState {
    return { error }
  }

  componentDidCatch(error: Error) {
    let storage: Storage | null = null
    try {
      storage = window.sessionStorage
    } catch {
      // The fallback remains visible when browser storage is disabled.
    }

    attemptStaleAssetReload(error, {
      now: Date.now,
      reload: () => window.location.reload(),
      storage,
    })
  }

  render() {
    if (this.state.error) {
      return (
        <main className="appCrashRecovery" role="alert">
          <section className="appCrashRecoveryCard">
            <h1>Không thể tải trang học tập</h1>
            <p>Vui lòng tải lại trang để tiếp tục.</p>
            <button onClick={() => window.location.reload()} type="button">Tải lại trang</button>
          </section>
        </main>
      )
    }

    return this.props.children
  }
}
